import 'interactjs'
import interact from 'interactjs';
import Point from 'interactjs'
import { histogramPredictionDataset, HistogramPrediction, brushingDataset } from '../Globals/Globals'
import { func } from 'prop-types';
import {Z_AXIS_SEPRATAION, } from '../Globals/Constants'
import {PREDICTION, SCATTERPLOT_CHART}  from "../GraphComponents/Canvas/Constants";
import {LogEvents} from '../Globals/Globals'
import { LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DRAG_ENDED } from '../Globals/LogConstants';
import {PREDICTION_COLOR,REALDATA_COLOR,BRUSHING_COLOR,NO_PREDICTION_COLOR} from "../Globals/ColorConstants"
import { fabric }  from "fabric";
export function dragableDiv(divId, divIdChildName1, divIdChildName2, divIdChildName3, divIdChildName4, divIdChildName5, divIdChildName6, divIdChildName7, divIdChildName8, divIdChildName9) {
 

  
  interact('.' + divId)
    .draggable({
      ignoreFrom: '.' + divIdChildName1 + ',' + '.' + divIdChildName2 + ',' + '.' + divIdChildName3 + ',' + '.' + divIdChildName4 + ',' + '.' + divIdChildName5 + ',' + '.' + divIdChildName6 + ',' + '.' + divIdChildName7 + ',' + '.' + divIdChildName8 + ',' + '.' + divIdChildName9,
      restrict: {
        restriction: 'parent',
        elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
      },
      
     
    }).on('dragstart', function(){
      var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
      if(logevents)
      {
              var eventlog = LogEvents.addEvent(divId, null, null, LOG_EVENT_TYPE_CHART_DRAG_STARTED, null, null,null,null,null)
              logevents._logEvents.push(eventlog)
              sessionStorage.setItem('logevents', JSON.stringify(logevents))
      }
    })
    .on('dragend', function (event) {
      var target = event.target
      console.log('dragend',target)

      var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
      if(logevents)
      {
              var eventlog = LogEvents.addEvent(divId, null, null, LOG_EVENT_TYPE_CHART_DRAG_ENDED, null, null,null,null,null)
              logevents._logEvents.push(eventlog)
              sessionStorage.setItem('logevents', JSON.stringify(logevents))
      }

    })
    .on('dragmove', function (event) {
      var target = event.target,
        // keep the dragged position in the data-x/data-y attributes
        x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
        y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      // translate the element
      target.style.webkitTransform =
        target.style.transform =
        'translate(' + x + 'px,' + y + 'px)';

      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    }).on('resizemove', function (event) {
      var target = event.target
      var x = (parseFloat(target.getAttribute('data-x')) || 0)
      var y = (parseFloat(target.getAttribute('data-y')) || 0)

      // update the element's style
      target.style.width = event.rect.width + 'px'
      target.style.height = event.rect.height + 'px'

      // translate when resizing from top or left edges
      x += event.deltaRect.left
      y += event.deltaRect.top

      target.style.webkitTransform = target.style.transform =
        'translate(' + x + 'px,' + y + 'px)'

      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
      //target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
    })
   
}

export function resizeTopRectBar(rectClassName, xaxis, yaxis, graphType) {



  if (histogramPredictionDataset.getInteractTop(rectClassName) == null) {
    console.log(histogramPredictionDataset.getInteractTop(rectClassName), 'resizeTopRectBar')
    interact('.' + rectClassName)
      .resizable({
        // resize from all edges and corners
        edges: { left: false, right: false, bottom: false, top: true },
        inertia: true
      })
      .on('resizestart', function (event) {
        var target = event.target
        var xforms = target.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);
        var height = parseFloat(target.getAttribute('height'));
        console.log('resizestart')
        var id_ = target.getAttribute('id')

        if (histogramPredictionDataset.getPredictionID(rectClassName) == null) {

        }
        else {
          if (histogramPredictionDataset.getPredictionID(rectClassName).get(id_) != null) {
            var histogramPrediction = histogramPredictionDataset.getPredictionID(rectClassName).get(id_)

            histogramPredictionDataset.getPredictionID(rectClassName).get(id_).setStart(histogramPrediction.linearYScale.invert(firstY),
              0)
          }
          else {

          }

        }


        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        {
                var eventlog = LogEvents.addEvent(rectClassName, graphType, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, null, null,xaxis,yaxis,null)
                logevents._logEvents.push(eventlog)
                sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }

      })
      .on('resizemove', function (event) {
     
        var target = event.target
        var x = (parseFloat(target.getAttribute('data-x')) || 0)
        var y = (parseFloat(target.getAttribute('data-y')) || 0)
        var id = target.getAttribute('class')
        // update the element's style
        // update the element's style
        var id_ = target.getAttribute('id')
        var height = histogramPredictionDataset.getPredictionID(rectClassName).get(id_).stopheight

        console.log(id)
        // translate when resizing from top or left edges
        var xforms = target.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);


        y = firstY
        y += event.deltaRect.top
        console.log('event', y, event.deltaRect.top, height, height - y)
        target.setAttribute('transform', 'translate(' + firstX + ',' + y + ')');
        target.setAttribute('height', height - y)
        console.log('firstX', firstX, firstY)
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
        // target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
      })
      .on('resizeend', function (event) {

        var target = event.target
        var x = (parseFloat(target.getAttribute('data-x')) || 0)
        var y = (parseFloat(target.getAttribute('data-y')) || 0)
        console.log('resizend', x, y)


        


        var xforms = target.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);
        var id_ = target.getAttribute('id')


        if (histogramPredictionDataset.getPredictionID(rectClassName) == null) {

        }
        else {
          if (histogramPredictionDataset.getInitial(rectClassName) == null) {
            histogramPredictionDataset.setInitial(rectClassName, true)
          }
          if (histogramPredictionDataset.getPredictionID(rectClassName).get(id_) != null) {
            var histogramPrediction = histogramPredictionDataset.getPredictionID(rectClassName).get(id_)

            histogramPredictionDataset.getPredictionID(rectClassName).get(id_).setStop(histogramPrediction.linearYScale.invert(firstY),
              0)
            console.log('histogramPredictionDataset interactfuns', histogramPrediction.linearYScale.invert(firstY))

            var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
            if(logevents)
            {
                    var eventlog = LogEvents.addEvent(rectClassName, graphType, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_ENDED,{id:id_,value:histogramPrediction.linearYScale.invert(firstY)}, null,xaxis,yaxis,null)
                    logevents._logEvents.push(eventlog)
                    sessionStorage.setItem('logevents', JSON.stringify(logevents))
            }
          }

        }




      })
  }

  if (histogramPredictionDataset.getInteractTop(rectClassName) == null) {
    histogramPredictionDataset.setInteractTop(rectClassName, true)



  }
}




export function resizeTopRect(rectClassName, xaxis, yaxis, graphType) {



  if (histogramPredictionDataset.getInteractTop(rectClassName) == null) {
    console.log(histogramPredictionDataset.getInteractTop(rectClassName), 'resizeTopRect')
    interact('.' + rectClassName)
      .resizable({
        // resize from all edges and corners
        edges: { left: false, right: false, bottom: false, top: true },
        inertia: true
      })
      .on('resizestart', function (event) {
        var target = event.target
        var xforms = target.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);
        var height = parseFloat(target.getAttribute('height'));

        var id_ = target.getAttribute('id')
        console.log('resizestart', id_, rectClassName)
        var acutalID = rectClassName.slice(0, rectClassName.lastIndexOf("_"))
        if (brushingDataset.getActualID(acutalID) != null) {
          if (brushingDataset.getActualID(acutalID).isPredictionStarted == null) {
            brushingDataset.getActualID(acutalID).isPredictionStarted = true
            brushingDataset.getActualID(acutalID)
          }

        }

        if (histogramPredictionDataset.getPredictionID(rectClassName) == null) {

        }
        else {

          if (histogramPredictionDataset.getPredictionID(rectClassName).get(id_) != null) {
            var histogramPrediction = histogramPredictionDataset.getPredictionID(rectClassName).get(id_)


            histogramPredictionDataset.getPredictionID(rectClassName).get(id_).setStart(histogramPrediction.linearYScale.invert(firstY),
              histogramPrediction.linearXScale.invert(firstX))
          }
          else {

          }

        }

        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        {
                var eventlog = LogEvents.addEvent(rectClassName, graphType, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, null, null,xaxis,yaxis,null)
                logevents._logEvents.push(eventlog)
                sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }
      })
      .on('resizemove', function (event) {
        console.log('resizemove')
        var target = event.target
        var x = (parseFloat(target.getAttribute('data-x')) || 0)
        var y = (parseFloat(target.getAttribute('data-y')) || 0)
        var id = target.getAttribute('class')
        // update the element's style
        // update the element's style
        var id_ = target.getAttribute('id')
        var height = histogramPredictionDataset.getPredictionID(rectClassName).get(id_).stopheight

        console.log(id)
        // translate when resizing from top or left edges
        var xforms = target.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);


        y = firstY
        y += event.deltaRect.top
        console.log('event', y, event.deltaRect.top, height, height - y)
        target.setAttribute('transform', 'translate(' + firstX + ',' + y + ')');
        target.setAttribute('height', height - y)
        console.log('firstX', firstX, firstY)
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
        // target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
      })
      .on('resizeend', function (event) {

        var target = event.target
        var x = (parseFloat(target.getAttribute('data-x')) || 0)
        var y = (parseFloat(target.getAttribute('data-y')) || 0)
        console.log('resizend', x, y)


        var xforms = target.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = parseFloat(parts[2]);
        var id_ = target.getAttribute('id')


        if (histogramPredictionDataset.getPredictionID(rectClassName) == null) {

        }
        else {
          if (histogramPredictionDataset.getInitial(rectClassName) == null) {
            histogramPredictionDataset.setInitial(rectClassName, true)
          }
          if (histogramPredictionDataset.getPredictionID(rectClassName).get(id_) != null) {
            var histogramPrediction = histogramPredictionDataset.getPredictionID(rectClassName).get(id_)

            histogramPredictionDataset.getPredictionID(rectClassName).get(id_).setStop(histogramPrediction.linearYScale.invert(firstY),
              histogramPrediction.linearXScale.invert(firstX))
            console.log('histogramPredictionDataset interactfuns', histogramPrediction.linearYScale.invert(firstY))

            var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
            if(logevents)
            {
                    var eventlog = LogEvents.addEvent(rectClassName, graphType, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_ENDED ,{id:id_,value:histogramPrediction.linearYScale.invert(firstY)}, null,xaxis,yaxis,null)
                    logevents._logEvents.push(eventlog)
                    sessionStorage.setItem('logevents', JSON.stringify(logevents))
            }
            
          }

        }




      })
  }

  if (histogramPredictionDataset.getInteractTop(rectClassName) == null) {
    histogramPredictionDataset.setInteractTop(rectClassName, true)


  }
}

export function resizableDiv(id, divId, setwidthUpdate, setheightUpdate, setZUpdate, settransformUpdate, setchanging, setyToolBoxMovement, idZ, Zflag) {
  var rightChange = false
  var topChange = false
  var height = ""
  var width = ""

  if(Zflag == true)
  {
    if (divId.includes('resize-rectX')) {
      rightChange = true
    }
    else if (divId.includes('resize-rectZ')) {
      topChange = true
    }
  }
  else
  {
    if (divId.includes('resize-rectX')) {
      rightChange = true
    }
    else if (divId.includes('resize-rectY')) {
      topChange = true
    }
  }
  
  console.log('divId', divId, topChange, rightChange)
  interact('.' + divId)
    .resizable({
      // resize from all edges and corners
      edges: { left: false, right: rightChange, bottom: false, top: topChange },
      inertia: true
    })
    .on('resizestart', function (event) {
      
      if(brushingDataset.getActualID(id).type == SCATTERPLOT_CHART)
      {
        
        console.log('resizestart',id)
      }
    })
    .on('resizemove', function (event) {
      var target = event.target
      var x = (parseFloat(target.getAttribute('data-x')) || 0)
      var y = (parseFloat(target.getAttribute('data-y')) || 0)
      var id = target.getAttribute('class')
      // update the element's style
      target.style.width = event.rect.width + 'px'
      target.style.height = event.rect.height + 'px'




      height = target.style.height
      width = target.style.width
      console.log(id)
      // translate when resizing from top or left edges


      x += event.deltaRect.left
      y += event.deltaRect.top
      target.style.webkitTransform = target.style.transform =
        'translate(' + x + 'px,' + y + 'px)'
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)

      
      console.log("resize-rectZ", event.rect.width, Zflag)
    
        if (divId.includes('resize-rectX')) {


          setwidthUpdate(event.rect.width)
         
          var element:HTMLElement = document.getElementsByClassName(idZ)[0] as HTMLElement
          element.style.left = event.rect.width + Z_AXIS_SEPRATAION + "px"
         
  
        }
        else if (divId.includes('resize-rectZ')) {
          var Ytarget = divId.replace('resize-rectZ', '')
          Ytarget = Ytarget+'resize-rectY'
          console.log('Ytarget',Ytarget)
          var YtargetClass = document.getElementsByClassName(Ytarget) as HTMLCollectionOf<HTMLElement>
          if(YtargetClass.length>0)
          {
            var YtargetEle =YtargetClass[0] as HTMLElement
            YtargetEle.style.transform ='translate(' + x + 'px,' + y + 'px)'
            YtargetEle.style.height = event.rect.height +"px"
            YtargetEle.setAttribute('data-x', x.toString())
            YtargetEle.setAttribute('data-y', y.toString())
          }

          setyToolBoxMovement(y)
          setheightUpdate(event.rect.height)
          setchanging('resize-rectZ')
          settransformUpdate('translate(' + x + 'px,' + y + 'px)')
          
          

  
        }
    
        else if (divId.includes('resize-rectY')) {
          var Ytarget = divId.replace('resize-rectY', '')
          Ytarget = Ytarget+'resize-rectZ'
          console.log('Ytarget',Ytarget)
          var ZtargetClass = document.getElementsByClassName(Ytarget) as HTMLCollectionOf<HTMLElement>
          if(ZtargetClass.length>0)
          {
            var Ztarget = ZtargetClass[0] as HTMLElement
            Ztarget.style.transform ='translate(' + x + 'px,' + y + 'px)'
            Ztarget.style.height = event.rect.height +"px"
            Ztarget.setAttribute('data-x', x.toString())
            Ztarget.setAttribute('data-y', y.toString())
          }
        

          setyToolBoxMovement(y)
          setheightUpdate(event.rect.height)
          setchanging('resize-rectY')
          settransformUpdate('translate(' + x + 'px,' + y + 'px)')
  
        }
      
      

   
      // target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
    }) .on('resizeend', function (event) {

   

    })
  return [width, height]
}